var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.598,
    height: 40.703,
    viewBox: "0 0 34.598 40.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.357,17.357h25.1v7.462h1.357V18.714h.678v6.105h1.357V18.035a.678.678,0,0,0-.678-.678H99.814v-.678A.678.678,0,0,0,99.135,16H72.678a.678.678,0,0,0-.678.678V28.889h1.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.357,184H72v24.422a.678.678,0,0,0,.678.678H95.743v-1.357H73.357Z",
    transform: "translate(0 -153.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.176,59.533a.678.678,0,0,0,.678-.678V48.678a.678.678,0,0,0-.678-.678h-9.5a.678.678,0,0,0-.678.678V58.854a.678.678,0,0,0,.678.678Zm-8.819-10.176H113.5v8.819h-8.141Z",
    transform: "translate(-29.286 -29.286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,128h10.176v1.357H248Z",
    transform: "translate(-161.076 -102.503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,168h10.176v1.357H248Z",
    transform: "translate(-161.076 -139.111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,208h6.784v1.357H104Z",
    transform: "translate(-29.286 -175.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,208h10.854v1.357H200Z",
    transform: "translate(-117.146 -175.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,248h14.924v1.357H104Z",
    transform: "translate(-29.286 -212.327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,288h6.784v1.357H104Z",
    transform: "translate(-29.286 -248.935)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,288h8.141v1.357H200Z",
    transform: "translate(-117.146 -248.935)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,328h2.035v1.357H296Z",
    transform: "translate(-205.005 -285.543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,328h14.924v1.357H104Z",
    transform: "translate(-29.286 -285.543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.176,48.678A.678.678,0,0,0,257.5,48h-8.819a.678.678,0,0,0-.678.678V52.07a.678.678,0,0,0,.678.678H257.5a.678.678,0,0,0,.678-.678Zm-1.357,2.714h-7.462V49.357h7.462Z",
    transform: "translate(-161.076 -29.286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,371.392A3.392,3.392,0,1,0,107.392,368,3.392,3.392,0,0,0,104,371.392Zm5.427,0a2.035,2.035,0,1,1-2.035-2.035A2.035,2.035,0,0,1,109.427,371.392Z",
    transform: "translate(-29.286 -322.151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,371.392A3.392,3.392,0,1,0,203.392,368,3.392,3.392,0,0,0,200,371.392Zm5.427,0a2.035,2.035,0,1,1-2.035-2.035A2.035,2.035,0,0,1,205.427,371.392Z",
    transform: "translate(-117.146 -322.151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.567,148.675l-3.49-10.471a3.218,3.218,0,0,0-3.057-2.2h-.88a.678.678,0,0,0-.678.678v10.176h-.352l-.391-.489a4.07,4.07,0,0,0-5.721-.636l-.743.595a.678.678,0,0,0-.119.937l5.97,7.96v10.628a.678.678,0,0,0,.678.678h6.105a.678.678,0,0,0,.678-.678v-6.105H308.21v5.427h-4.749V154.995a.678.678,0,0,0-.136-.407l-5.711-7.615.23-.184a2.714,2.714,0,0,1,3.814.424l.595.743a.678.678,0,0,0,.53.254h1.357a.678.678,0,0,0,.678-.678V137.357h.2a1.863,1.863,0,0,1,1.77,1.276L310.245,149v1.124l-1.992,5.312a.679.679,0,0,0-.043.238v2.714h1.357V155.8l1.992-5.312a.678.678,0,0,0,.043-.238v-1.357a.678.678,0,0,0-.035-.214Z",
    transform: "translate(-205.004 -109.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,384h5.427v1.357H296Z",
    transform: "translate(-205.005 -336.794)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,416h1.357v1.357H296Z",
    transform: "translate(-205.005 -366.081)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,416h2.714v1.357H328Z",
    transform: "translate(-234.292 -366.081)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForm);
export default __webpack_public_path__ + "static/media/icon-form.0ae574493d95190eefe0e7e54d507f2c.svg";
export { ForwardRef as ReactComponent };